import App from './global/App';

let app = new App();

window.$(document).ready(() => {
    app.onReady();
});


// WEBPACK FOOTER //
// ./app/index.js